module.exports = __webpack_public_path__ + "img/rowC5.ded768c9.png";